/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Button } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IInvoicesListViewProps } from '@msdyn365-commerce-modules/invoice/src/modules/invoices-list/./invoices-list';
import { getInvoiceDetailsPageUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { OrderInvoice } from '@msdyn365-commerce/retail-proxy';
import { ICoreContext, IDateFormatOptions } from '@msdyn365-commerce/core-internal';
import { IInvoicesListProps } from '../definition-extensions/invoices-list.ext.props.autogenerated';
import { getUrlSync } from '@msdyn365-commerce/core';
interface IGroupInvoice {
    invoice: OrderInvoice[];
    group: string;
}
export const InvoiceListView: React.FC<IInvoicesListViewProps & IInvoicesListProps<{}>> = props => {
    //const { invoiceIDLabel } = props.resources;
    const [invoiceList, setInvoiceList] = React.useState<OrderInvoice[]>([]);

    React.useEffect(() => {
        const invoices = props.data.invoices.result!;
        invoices && setInvoiceList([...invoiceList, ...invoices]);
    }, [props.data.invoices.result]);
    const { header, filter, invoiceRequestModal, pagination } = props;
    const _className: string = 'msc-invoices-list';
    const formatDate = (context: ICoreContext, date: Date | undefined) => {
        if (date === undefined) {
            return '';
        }
        const dateOptions: IDateFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };

        return context.cultureFormatter.formatDate(date, dateOptions);
    };
    const _renderEmptyInvoiceLinesPageContent = (): JSX.Element => {
        const containerClass = `${_className}__empty-lines__container`;
        const actionsContainerClass = `${containerClass}__actions`;
        return (
            <div className={containerClass}>
                <div className={`${containerClass}__title`}>{props.resources.invoiceEmptyInvoiceLinesTitle}</div>
                <div className={`${containerClass}__description`}>{props.resources.invoiceEmptyInvoiceLinesDescription}</div>
                <div className={actionsContainerClass}>
                    <Button
                        className={`${actionsContainerClass}__continue-shopping`}
                        aria-label={props.resources.invoiceEmptyInvoiceLinesContinueShoppingButtonAriaLabel}
                        href={getUrlSync('home', props.context.actionContext)}
                    >
                        {props.resources.invoiceEmptyInvoiceLinesContinueShoppingButtonText}
                    </Button>
                </div>
            </div>
        );
    };

    let _renderInvoicesList;
    if (invoiceList?.length > 0) {
        let groups = invoiceList.reduce((pre, crr) => {
            let c = formatDate(props.context, crr.InvoiceDate).split(' ');
            let m = `${c[0]} ${c[2]}`;
            if (pre[m]) {
                pre[m].invoice.push(crr);
            } else {
                const grpInvoice: IGroupInvoice = {
                    invoice: [crr],
                    group: m
                };
                pre[m] = grpInvoice;
            }
            return pre;
        }, {});
        let groupByInvoice = Object.keys(groups).map(k => groups[k]);

        _renderInvoicesList = groupByInvoice.map(groupInvoice => {
            return (
                <>
                    <h2>{groupInvoice?.group}</h2>
                    {groupInvoice.invoice?.map((invoice: any) => {
                        const linkToInvoiceDetails = getInvoiceDetailsPageUrlSync(invoice.Id!, props.context.actionContext);
                        return (
                            <div className='invoice-box'>
                                <a href={linkToInvoiceDetails}>
                                    <strong className='inDate'>{formatDate(props.context, invoice.InvoiceDate)}</strong>
                                    {/* <h3>{invoice.CustomerName}</h3> */}
                                    {/* <span className='inv-num'>
                                        {invoiceIDLabel} {invoice.Id}
                                    </span> */}
                                    {/* <div className='order'>{invoice.InvoiceTypeValue} Order</div> */}
                                    <strong className='price-box'>${invoice.TotalAmount}</strong>
                                </a>
                            </div>
                        );
                    })}
                </>
            );
        });
    } else {
        _renderInvoicesList = _renderEmptyInvoiceLinesPageContent();
    }
    return (
        <Module {...props.moduleProps}>
            {header}
            {invoiceRequestModal}
            {filter}
            {/* {content} */}
            <div className='invoice-list'>{_renderInvoicesList}</div>
            {pagination}
        </Module>
    );
};

export default InvoiceListView;
